import Vue from 'vue'
import Vuex from 'vuex'
import { authApi, membershipApi } from '@/api'

Vue.use(Vuex)

const stored = localStorage.getItem('wd_user')

function readDataAccess(user) {
  if (!user) return false
  if (user.role === 1) return true
  if (typeof user.hasDataAccess === 'boolean') return user.hasDataAccess
  if (!user.isSubscribed) return false
  if (user.dataExpiresAt && new Date(user.dataExpiresAt) < new Date()) return false
  if (user.subscriptionExpiresAt && new Date(user.subscriptionExpiresAt) < new Date()) return false
  return true
}

function readKnowledgeAccess(user) {
  if (!user) return false
  if (user.role === 1) return true
  if (typeof user.hasKnowledgeAccess === 'boolean') return user.hasKnowledgeAccess
  return false
}

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('wd_token') || null,
    user: stored ? JSON.parse(stored) : null
  },
  getters: {
    isLoggedIn: s => !!s.token,
    isAdmin: s => s.user?.role === 1,
    currentUser: s => s.user,
    hasDataAccess: s => readDataAccess(s.user),
    hasKnowledgeAccess: s => readKnowledgeAccess(s.user),
    isInDataTrial: s => !!s.user?.isInDataTrial,
    dataTrialDaysLeft: s => s.user?.dataTrialDaysLeft ?? 0,
    isSubscribed: s => readDataAccess(s.user),
    canDownload: s => !!s.user?.canDownload
  },
  mutations: {
    SET_AUTH(state, { token, user }) {
      state.token = token
      state.user = user
      localStorage.setItem('wd_token', token)
      localStorage.setItem('wd_user', JSON.stringify(user))
    },
    CLEAR_AUTH(state) {
      state.token = null
      state.user = null
      localStorage.removeItem('wd_token')
      localStorage.removeItem('wd_user')
    },
    UPDATE_USER(state, user) {
      state.user = user
      localStorage.setItem('wd_user', JSON.stringify(user))
    }
  },
  actions: {
    async login({ commit }, credentials) {
      try {
        const res = await authApi.login(credentials)
        if (res.success) {
          commit('SET_AUTH', { token: res.data.token, user: res.data.user })
        }
        return res
      } catch (e) {
        return { success: false, message: e?.response?.data?.message || '网络错误，请稍后重试' }
      }
    },
    async register({ commit }, data) {
      try {
        const res = await authApi.register(data)
        if (res.success) {
          commit('SET_AUTH', { token: res.data.token, user: res.data.user })
        }
        return res
      } catch (e) {
        return { success: false, message: e?.response?.data?.message || '网络错误，请稍后重试' }
      }
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    },
    async refreshUser({ commit }) {
      try {
        const res = await authApi.me()
        if (res.success) commit('UPDATE_USER', res.data)
      } catch { /* ignore */ }
    },
    async refreshMembership({ commit, state }) {
      if (!state.token) return
      try {
        const res = await membershipApi.status()
        if (res.success && state.user) {
          commit('UPDATE_USER', {
            ...state.user,
            hasDataAccess: res.data.hasDataAccess,
            hasKnowledgeAccess: res.data.hasKnowledgeAccess,
            isInDataTrial: res.data.isInDataTrial,
            dataTrialDaysLeft: res.data.dataTrialDaysLeft,
            dataExpiresAt: res.data.dataExpiresAt,
            knowledgeExpiresAt: res.data.knowledgeExpiresAt,
            isSubscribed: res.data.hasDataAccess,
            subscriptionExpiresAt: res.data.dataExpiresAt
          })
        }
      } catch { /* ignore */ }
    },
    async refreshToken({ commit }) {
      try {
        const res = await authApi.refresh()
        if (res.success) {
          commit('SET_AUTH', { token: res.data.token, user: res.data.user })
        }
        return res
      } catch { return { success: false } }
    }
  }
})
